// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"49705a30bc418646","4275":"b01ee74d00b3f328","6741":"f3365c7204367b32","9586":"bef55704f3278ac2"}[chunkId] + ".css";
};